// extracted by mini-css-extract-plugin
var _1 = "KAgpPCYvN3";
export { _1 as "root" }
